import { useState, useMemo, useEffect, useRef } from "react";
import Select from 'react-select';

import { onTabChange, clearSelectedRowsData } from "../../../redux/features/table/tableSlice";
import TableFilters from "../../../Components/common/TableGrid/TableFilters";
import TableTabs from "../../../Components/common/TableGrid/TableTabs";
import TableGrid from "../../../Components/common/TableGrid";

import tripstoday from '../../../assets/images/slotplanning/tripstoday.svg';
import onpremises from '../../../assets/images/slotplanning/onpremises.svg';
import inprogress from '../../../assets/images/slotplanning/inprogress.svg';

import discrepancies_operational from "../../../assets/images/icon_svg/AWBsearch.svg" 
import discrepancies_planning from "../../../assets/images/icon_svg/dis_planning.svg" 
import open_discrepancies from "../../../assets/images/icon_svg/dis_icon.svg"

import arriving from '../../../assets/images/slotplanning/arriving.svg';
import { useSelector, useDispatch } from "react-redux";
import { useGetDiscrepancyListQuery } from "../../../redux/services/ARFSM";

import { ReactComponent as EyeIcon } from "../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { ReactComponent as ArchiveIcon } from "../../../assets/images/slotplanning/archive_icon.svg";
import CommonCard from "../../../Components/common/CommonCard";
import { toast } from "react-toastify";
import ConfModal from "../../../Components/common/ConfModal";
import { withRFSToken } from "../../../Services/axios";
import { GETDESTINATION } from "../../../Utils/conts";
import { CallApi, CommonModal, getTodayDateTime } from "../../../Components/common/CommonFunctions";
import { Button, Col, Form, Row } from "react-bootstrap";

const Discrepancies = ({ onDetails }) => {

  const isMounted = useRef(false);
  const [modalConf, setModalConf] = useState(false);
  const [confData, setConfData] = useState({});
  const [formData, setFormData] = useState({});
  const [resolutionType, setResolutionType] = useState([])
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
  const dispatch = useDispatch();
  const [getDestination, setGetDestination] = useState([]);
  const [show, setShow] = useState(false)
  const [selectedDiscrepancy, setSelectedDiscrepancy] = useState([]);
  const [isBulkResolve, setIsBulkResolve] = useState(false);

  const fetchDestination = async () => {
      try {
          const res = await withRFSToken.post(GETDESTINATION, {})
              .then(function (res) {
                  const innerData = res.data.response_data;
                  const transformedData = innerData ? innerData.map(item => ({
                      value: item.port_code,
                      label: item.port_code,
                  })) : [];
                  setGetDestination(transformedData);
              });

      } catch (error) {
          console.error('Error fetching data:', error);
      }
  };

  useEffect(() => {
      dispatch(onTabChange({ key: 'status', value: "O" }));
      if (isMounted.current) return;
      fetchDestination();
      fetchResolutionType();
      isMounted.current = true;
  }, []);

  const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
                return;
            }
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value); // [187,186]
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);
    const params = {
      ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
    };
    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    if (tab?.value && tab.key) {
      params[tab.key] = tab.value;
    }
    return params;
  }, [filters, pageDetails, sortby]);

  const { data: myData, isFetching, refetch } = useGetDiscrepancyListQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const filtersConfig = [
    {
      type: "input",
      field: "truck_number",
      placeholder: "Search Truck No.",
    },
    {
      type: "multiselect",
      field: "category",
      placeholder: "Category",
      class: 'dw-13',
      options: [
        { label: "Operational", value: "Operational" },
        { label: "Planning", value: "Planning" },
      ],
    },
    {
      type: "multiselect",
      field: "station",
      placeholder: "Station",
      class: 'dw-13',
      options: getDestination?.map((item) => ({
        label: item.label,
        value: item.value,
      })) || [],
    },
  ];

  const tabsConfig = [
    { label: "All", value: "A", paramKey: 'status' },
    { label: "Open", value: "O", paramKey: "status" },
    { label: "Closed", value: "C", paramKey: "status" },
  ];

  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: 'tw-3',
      renderCell: (row) => (
        <div className="tb_grid_actions">
          <EyeIcon className="icon_light_gray" style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setIsBulkResolve(false);
              setShow(true)
              setSelectedDiscrepancy([row]);
              // loadDetails(row);
            }}
          />
        </div>
      ),
    },
    {
      label: "Discrepancy Type", field: "discrepancy_type", enableSearch: false, cls: 'tw-6', renderCell: (row) => {
        const discrepancy_type = row?.detail?.discrepancy_summary?.discrepancy_type;
        return (<>{discrepancy_type}</>);
      }
    },
    {
      label: "Category", field: "category", enableSearch: false, cls: 'tw-6', renderCell: (row) => {
        const category = row?.detail?.discrepancy_summary?.category;
        return (<>{category}</>);
      }
    },
    { label: "Truck No.", field: "truck_number", enableSearch: false, cls: 'tw-6' },
    {
      label: "Truck Date", field: "truck_date", enableSearch: false, cls: 'tw-7', renderCell: (row) => (
        <>{getTodayDateTime(row.truck_date, "DMY")}</>
      )
    },
    { label: "Station", field: "station", enableSearch: false, cls: 'tw-5' },
    {
      label: "Identified On", field: "identified_on", enableSearch: false, renderCell: (row) => {
        const identified_on = row?.list?.identified_on;
        return (<>{getTodayDateTime(identified_on, "DMY")}</>);
      }
    },
  ];

  const handleMoveToActArc = () => {
    const isActiveTab = tab?.value === 'A';
    setConfData({
      header: `Selected Data move to ${isActiveTab ? 'Archive' : 'Active'}`,
      subHeader: `Are you sure you want to ${isActiveTab ? 'Archive' : 'Activate'}?`,
      primaryBtn: 'Confirm',
      secondaryBtn: 'Cancel',
      modalConf: tabChangeConf,
    });
    setModalConf(true);
  };

  const handleResolve = () => {
    setIsBulkResolve(true);
    setFormData({});
    setShow(true)
  }

  const tabChangeConf = async () => {
    const payload = {
      ids: selectedRows.map(row => row.id),
    };
    try {
      const res = await withRFSToken.post('toggle-truck-status', payload);
      if (res.data.response_code === 200) {
        dispatch(clearSelectedRowsData(true));
        toast.success(res.data.response_msg);
        setModalConf(false);
        refetch();
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('Something went wrong');
    }
  };

    const fetchResolutionType = async () => {
            CallApi({
                endPoint: "discrepancy/get-resolution-type",
                method: "get",
                onSuccess: (res) => {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.value,
                        label: item.label
                    })) : [];
                    setResolutionType(transformedData);
                },
                onError: (msg) => console.error(msg)
            });
        };

  const confModalClose = () => {
    setModalConf(false);
  };

  const bulkActions = [
  ...(tab?.value === "A"
    ? [{ label: "Archive", action: handleMoveToActArc, icon: ArchiveIcon }]
    : tab?.value === "R"
      ? [{ label: "Activate", action: handleMoveToActArc, icon: ArchiveIcon }]
      : []),
  {
    label: "Resolve", action: handleResolve, icon: ArchiveIcon, // replace with your icon
  },
];

  const cards = [
    { icon: 'open_discrepancies', title: 'Open Discrepancies', value: myData?.ActiveAwbCount },
    { icon: 'discrepancies_planning', title: 'Discrepancies - Planning', value: myData?.planningCount },
    { icon: 'discrepancies_operational', title: 'Discrepancies - Operational', value: myData?.operationalCount },
    { icon: '', title: ' - ', value: '-' }, //arriving
  ];
  const iconMap = { open_discrepancies, discrepancies_planning, discrepancies_operational }; //arriving

  const handleResolutionFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
  }

  const closeResolutionModal = () =>{
    setShow(false)
    setSelectedDiscrepancy([])
     setIsBulkResolve(false)
  }

  const handleResolveDiscrepancy = () => {
    const truckId = isBulkResolve
      ? selectedRows.map((t) => t.id)
      : selectedDiscrepancy.map((t) => t.id);

    if (!isBulkResolve && !formData?.resolution_type) {
      toast.error("Resolution type is required");
      return;
    }

    const payload = {
      discrepancy_id: truckId,
      resolution_notes: formData?.resolution_notes,
      ...(isBulkResolve ? {} : { resolution_type: formData?.resolution_type }),
    };

    CallApi({
      endPoint: "discrepancy/resolve",
      method: "post",
      payload: payload,
      onSuccess: (res) => {
        if (res?.data?.response_code == 200) {
          toast.success("Resolved successfully!");
          setShow(false)
          setSelectedDiscrepancy([])
          setIsBulkResolve(false)
          dispatch(clearSelectedRowsData(true));
          setFormData({});
          refetch();
        } else {
          toast.error(res?.data?.response_msg || 'Error while Resolving');
        }
      },
      onError: (err) => {
        console.error(err);
      },
    });
  };

  return (
    <>
      {modalConf &&
        <ConfModal
          header={confData.header}
          subHeader={confData.subHeader}
          modalConf={confData.modalConf}
          closeModal={confModalClose}
          primaryBtn={confData.primaryBtn}
          secondaryBtn={confData.secondaryBtn}
        />
      }
      <div className="main-content">
        {cards?.length ?
          <div className="card-bx">
            {cards?.map((item, index) => (
              <CommonCard key={index} icon={iconMap[item.icon]} title={item.title} value={item.value} />
            ))}
          </div>
          : <></>
        }
        <div className="d-flex justify-content-between align-items-center mb-3">
          <TableFilters filtersConfig={filtersConfig} />
          <TableTabs tabs={tabsConfig} />
        </div>

        <div>
          <TableGrid
            columns={columns}
            rows={myData?.Rows}
            checkboxSelection={true}
            totalRecords={myData?.TotalRows || 0}
            onClickRow={(row) => {
              console.log("Clicked Row:", row);
              setSelectedDiscrepancy((prev) => [...prev, row]);
            }}
            loading={isFetching}
            bulkActions={bulkActions}
            rowKey="id"
          />
        </div>
            <CommonModal
              // mSize="xl"
              show={show}
              onHide={closeResolutionModal}
              title={`Resolve Discrepancy (${selectedRows?.length})`}
              subTitle="Resolve the selected discrepancies in one action."
              className="modal_bgw primary_modal"
              footer={
                <div className="d-flex justify-content-between w-100">
                  <Button onClick={()=>setShow(false)} variant="secondary" >Cancel</Button> 
                  <Button variant="primary" className="ms-auto" onClick={handleResolveDiscrepancy}>Resolve Discrepancy</Button>
                </div>
              }
            >
              <div className="resolve_dis">
                <Row>
                  <Col>
                    <div>
                      <Form>
                        <Form.Label>Resolution Type {!isBulkResolve && <span className="red">*</span>}</Form.Label>
                        <Select
                          options={resolutionType}
                          onChange={(selected) => {
                              const selectedRosulation = resolutionType.find(option => option.value === selected.value);
                              setFormData(prev => ({
                                  ...prev,
                                  resolution_type: selected.value,
                              }));
                          }}
                          placeholder="Resolution Type"
                          className="autoslct w-100"
                          name="resolution_type"
                          value={resolutionType.find(option => option.value === formData.resolution_type)}
                          isDisabled={isBulkResolve}
                      />
                        <Form.Label>Resolution Notes </Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder="Describe what was done to resolve this discrepancy."
                          name='resolution_notes'
                          onChange={(e) => handleResolutionFormChange('resolution_notes', e.target.value)}
                          className="custom-textarea"
                        />              
                      </Form>
                    </div>
                  </Col>
                </Row>
              </div>
            </CommonModal>
      </div>
    </>
  );
};

export default Discrepancies;